import 'react';
import { formatNumber } from '@atc/string-fns';
import clsx from 'clsx';
import { RadioGroup } from 'reaxl-forms';
import RatesTable from './RatesTable.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const formatSelectOptions = function (options) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return [...options.map(option => {
    const formattedOption = formatNumber({
      value: option
    });
    return {
      value: option.toString(),
      label: unit ? `${formattedOption} ${unit}` : formattedOption
    };
  })];
};
function TermSelect(_ref) {
  let {
    value,
    options = [],
    handleChange,
    disabled = false,
    label,
    labelClassName,
    name = 'defaultInput',
    className,
    rates,
    supportingLink,
    isLoading
  } = _ref;
  const unit = {
    termInput: 'months'
  }[name];
  const formattedOptions = options[0]?.label !== undefined && options[0]?.value !== undefined ? options : formatSelectOptions(options, unit);

  // overide the default 10px bottom margin of the last radio input
  // the spacing should be decided by the supporting link
  if (supportingLink && formattedOptions && formattedOptions.length > 0) {
    formattedOptions[formattedOptions.length - 1].optionClassNames = 'margin-bottom-0';
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(RadioGroup, {
      name: name,
      id: name,
      value: value,
      options: formattedOptions,
      onChange: handleChange,
      disabled: disabled,
      label: label,
      labelClassName: clsx('text-gray-base', labelClassName),
      rootClasses: className
    }), (rates || isLoading) && /*#__PURE__*/jsx(RatesTable, {
      ratesData: rates,
      selectedLoanTerm: value,
      isLoading: isLoading
    }), !!supportingLink && supportingLink]
  });
}
export { TermSelect as default };
